export { HeroSlide } from './hero_slide';
